export const config = {
  TOKEN_COOKIE: 'access_token',
  CONTROL_HEADER: 'X-ELS-ControlHeader',
  STATION_ID: 'station_id',
  COUNT_OF_ITEMS: 7, // this is done by the backend (used for filters more button)
  FILTER_MAX_GROUP_COUNT: 15,
  NUMBER_OF_PAGE_ITEMS: 20,
  PAGE_RANGE_MIN: 3,
  PAGE_RANGE_MAX: 5,
  PAGE_GOTO_CUTOFF: 7,
  POPUP_FOCUS_TIMEOUT: 200,
  NOTIFY_MODAL_OPTIONS: {
    defaultResolve: {
      animation: true,
      windowClass: 'rx-notify-modal',
      backdrop: 'static',
      size: 'big',
    },
  },
  MODAL_OPTIONS: {
    defaultResolve: {
      animation: true,
      size: 'auto',
      keyboard: true,
      windowTemplateUrl: 'common/rx-ui/views/rx-modal/rx-modal.html',
      backdrop: 'static',
      openedClass: 'modal-open-with-scroll', // enabling scrolling on body
    },
  },
  BUILD_BY_TYPE_OPTIONS: {
    typeaheadQueryMinLength: {
      stringField: 1,
      numericField: 1,
    },
  },
  LOAD_MORE_LOADER_ID: 'load-more',
};

export const structureFilter = {
  name: 'structureFilter',
  expanded: 'structureFilterExpanded',
};

export const imageTypes = {
  RESULTS_S: 'RESULTS_S',
  RESULTS_M: 'RESULTS_M',
  RESULTS_L: 'RESULTS_L',
  HUGESUBST_MODAL: 'HUGESUBST_MODAL',
  REACTION: 'REACTION',
  MARKUSH: 'MARKUSH',
  SIMILARITY: 'SIMILARITY',
  PLANNER_XS: 'PLANNER_XS',
  PLANNER_S: 'PLANNER_S',
  PLANNER_M: 'PLANNER_M',
  DOCDETAILS: 'DOCDETAILS',
  GSFN: 'GSFN',
  HEATMAP_THUMBNAIL: 'HEATMAP_THUMBNAIL',
  HISTORY_THUMBNAIL_REACTION: 'HISTORY_THUMBNAIL_REACTION',
  HISTORY_THUMBNAIL_SUBSTANCE: 'HISTORY_THUMBNAIL_SUBSTANCE',
  HISTORY_THUMBNAIL: 'HISTORY_THUMBNAIL',
  ALERT_THUMBNAIL: 'ALERT_THUMBNAIL',
};

export const structureThumbnailLabel = 'No Image';

export const FILTER_BY_VALUE_MODAL_CONF = {
  title: 'Close filter by value?',
  text: 'Closing the filter by value control will remove all entered values. Do you want to continue?',
  cancelText: 'Cancel',
  confirmText: 'Yes',
  type: 'info',
  backdrop: 'static',
};

export const FEATURES = {
  pending_ai_rt: 'pending_ai_rt',
  iktos_rt: 'iktos_rt',
  createAlertDaysBeforeNow: 'createAlertDaysBeforeNow',
  displayQuickSearchFormsButtons: 'displayQuickSearchFormsButtons',
  enabledReactStructureSynthesisPlanner: 'enabledReactStructureSynthesisPlanner',
  bundleExtraReactionData: 'bundleExtraReactionData',
  useHttpPolling: 'useHttpPolling',
  // RCC features
  disablePatentSightUIChanges: 'disablePatentSightUIChanges',
  disableRccContentFrom: 'disableRccContentFrom',
  enableRccDocumentProcessedTypeLabel: 'enableRccDocumentProcessedTypeLabel',
  disableCasNumberCta: 'disableCasNumberCta',
  enableProductSelection: 'enableProductSelection',
  enableInHouseForEditableRetrosynthesisPlans: 'enableInHouseForEditableRetrosynthesisPlans',
  enableDisplaySupplierNumber: 'enableDisplaySupplierNumber',
  enableReactionExportAsRDFile: 'enableReactionExportAsRDFile',
  image_generation_requests_limit: 'image_generation_requests_limit',
  enable_auto_align_mapper: 'enable_auto_align_mapper',
  enableStructureHighlighting: 'enableStructureHighlighting',
  enableJournalTitleRadioButtons: 'enableJournalTitleRadioButtons',
  enableEditSynonyms: 'enableEditSynonyms',
  enableProjectImport: 'enableProjectImport',
  enableBioactivityVisualizationButtonOnPreviewResults: 'enableBioactivityVisualizationButtonOnPreviewResults',
  disableMicrosoftExcelNewLayoutInHeatMapExportModal: 'disableMicrosoftExcelNewLayoutInHeatMapExportModal',
  enableBioactivityVisualizationSettings: 'enableBioactivityVisualizationSettings',
  enableSortByPublicationYearDefault: 'enableSortByPublicationYearDefault',
  enableIntegratedFeedback: 'enableIntegratedFeedback',
  bottomIntegratedFeedback: 'bottomIntegratedFeedback',
  topAndBottomIntegratedFeedback: 'topAndBottomIntegratedFeedback',
  extendedOnNegativeFeedbackOnly: 'extendedOnNegativeFeedbackOnly',
  enableStaticQuickSearchExamples: 'enableStaticQuickSearchExamples',
  enableAuthorNameSearchImprovements: 'enableAuthorNameSearchImprovements',
  block_additional_alert_email: 'block_additional_alert_email',
  texel_access_enabled: 'texel_access_enabled',
  hideRCSFiltersExcludeButton: 'hideRCSFiltersExcludeButton',
  hideRCSStructureFilter: 'hideRCSStructureFilter',
  hideRCSSDSFilter: 'hideRCSSDSFilter',
};
